/* NZS nav skeleton — page-type-aware wireframe overlay shown during full-page navigation.
   Server-rendered theme: the old page stays on screen during the click->response gap, so we
   deliberately overlay a destination-shaped skeleton (cleared automatically when the new doc loads).
   B0 WARM-HANDOFF COUPLING: layout/theme.liquid consumes sessionStorage.nzsSkNav. Never persist
   nzs-nav-sk--bar here, and keep the matching bootstrap guard that rejects a carried bar overlay.
   Vanilla, no deps. Loaded with `defer` from layout/theme.liquid. Kill switch: window.__nzsNavSkOff=true. */
(function(){
  if (window.Shopify && Shopify.designMode) return;   // theme editor: never obscure the canvas
  if (window.__nzsNavSkOff) return;                    // global kill switch
  if (window.__nzsNavSk) return; window.__nzsNavSk = 1;

  var DELAY = 150, SAFETY = 8000, t = null, safety = null, statusTick = null, el = null, statusEl = null;
  var inertRoot = null, inertSet = false, focusEl = null;
  var HAS = Object.prototype.hasOwnProperty;
  var SELF_KEY = 'nzsSkSuffix:';

  var PAGE_KIND = {"about":"art","best-energy-drinks-nz":"art","best-pre-workout-nz":"art","best-protein-powder-nz":"art","blakes-stack":"stack","build-your-stack":"builder","compare":"compare","contact":"art","contact-company":"art","energy-focus-stack":"stack","everyday-health-stack":"stack","faq":"help","favourites":"coll","featured-pre-workout":"coll","find-your-pre-workout":"quiz","find-your-stack":"quiz","fuel-your-whole-day":"stack","gym-starter-stack":"stack","muscle-size-stack":"stack","shop-by-brand":"brandidx","shop-by-category":"catidx","shop-by-goal":"shopidx","shred-lean-stack":"stack","sleep-recovery-stack":"stack","track-my-order":"art","winter-immunity-stack":"stack","wishlist":"coll","your-stack":"review"};
  var SUFFIX_KIND = {"":"art","about":"art","blakes-stack":"stack","compare":"compare","contact":"art","day-stack":"stack","energy-compare":"art","energy-stack":"stack","faq":"help","favourites":"coll","featured-pre-workout":"coll","find-your-pre-workout":"quiz","find-your-stack":"quiz","health-stack":"stack","immunity-stack":"stack","muscle-stack":"stack","none":"art","protein-compare":"art","pw-compare":"art","shop-by-brand":"brandidx","shop-by-category":"catidx","shop-by-goal":"shopidx","shred-stack":"stack","sleep-stack":"stack","stack-builder":"builder","starter-stack":"stack","track-my-order":"art","wishlist":"coll","your-stack":"review"};

  function fill(n, s){ var o = ''; while (n-- > 0) o += s; return o; }
  /* NZS-SKEL-0924: every wireframe mirrors its settled page (measured at 375 + 1280 wide). Builders keep
     each node a DIV carrying only nzs-sk* classes so the layout/theme.liquid warm-handoff validator still passes. */
  function B(c){ return '<div class="nzs-sk ' + c + '"></div>'; }
  function D(c, inner){ return '<div class="' + c + '">' + (inner || '') + '</div>'; }
  function lines(n, c){ var o = ''; for (var i = 1; i <= n; i++) o += B(c + ' ' + c + '--' + i); return o; }
  var PRODUCT_CARD = D('nzs-sk-pc', B('nzs-sk-pc__media') + D('nzs-sk-pc__body',
    B('nzs-sk-pc__t') + B('nzs-sk-pc__t nzs-sk-pc__t--2') + B('nzs-sk-pc__t nzs-sk-pc__t--3') +
    B('nzs-sk-pc__price') + B('nzs-sk-pc__note') + B('nzs-sk-pc__pill') + B('nzs-sk-pc__atc')));
  var TOOLBAR = D('nzs-sk-tb', B('nzs-sk-tb__fil') + B('nzs-sk-tb__count') +
    D('nzs-sk-tb__end', B('nzs-sk-tb__view') + B('nzs-sk-tb__view') + B('nzs-sk-tb__sort')));
  var SUBC_TILE = D('nzs-sk-sct', B('nzs-sk-sct__m') + B('nzs-sk-sct__n') + B('nzs-sk-sct__c'));
  var LIST_TILE = D('nzs-sk-lct', B('nzs-sk-lct__m') + B('nzs-sk-lct__t') + B('nzs-sk-lct__t nzs-sk-lct__t--2') + B('nzs-sk-lct__c'));
  var BLOG_CARD = D('nzs-sk-bc', B('nzs-sk-bc__m') + B('nzs-sk-bc__t') + B('nzs-sk-bc__t nzs-sk-bc__t--2') +
    B('nzs-sk-bc__x') + B('nzs-sk-bc__x nzs-sk-bc__x--2') + B('nzs-sk-bc__d'));
  function IDX(k, card, n){                              /* shop-by-brand / category / goal share one head */
    return D('nzs-nav-sk__wrap nzs-sk-si', D('nzs-sk-si__head', B('nzs-sk-si__t') + fill(8, B('nzs-sk-si__i'))) +
      D('nzs-sk-grid nzs-sk-si__grid nzs-sk-si__grid--' + k, fill(n, card)));
  }
  var IDX_FOOT = D('nzs-sk-si__foot', B('nzs-sk-si__cnt') + B('nzs-sk-si__arr'));
  var BRAND_CARD = D('nzs-sk-si__card', B('nzs-sk-si__logo') + B('nzs-sk-si__nm') + B('nzs-sk-si__cn'));
  var CAT_CARD = D('nzs-sk-si__card', B('nzs-sk-si__m') + B('nzs-sk-si__nm') + B('nzs-sk-si__sub') + IDX_FOOT +
    D('nzs-sk-si__chips', lines(6, 'nzs-sk-si__chip')));
  var GOAL_CARD = D('nzs-sk-si__card', B('nzs-sk-si__m') + B('nzs-sk-si__nm') + B('nzs-sk-si__sub') + IDX_FOOT);
  var CART_ROW = D('nzs-sk-cr', B('nzs-sk-cr__m') +
    D('nzs-sk-cr__c', lines(3, 'nzs-sk-cr__t') + B('nzs-sk-cr__p') + B('nzs-sk-cr__ps') + B('nzs-sk-cr__q') + B('nzs-sk-cr__sub')) +
    D('nzs-sk-cr__r', B('nzs-sk-cr__lp') + B('nzs-sk-cr__rm')));
  var DS_SLOT = D('nzs-sk-ds__slot', B('nzs-sk-ds__lab') + B('nzs-sk-ds__help') +
    D('nzs-sk-ds__card', B('nzs-sk-ds__m') + B('nzs-sk-ds__chip') + B('nzs-sk-ds__t') + B('nzs-sk-ds__t nzs-sk-ds__t--2') +
      D('nzs-sk-ds__pr', B('nzs-sk-ds__was') + B('nzs-sk-ds__now'))));
  var RV_LINE = D('nzs-sk-rv__line', B('nzs-sk-rv__img') + D('nzs-sk-rv__txt', B('nzs-sk-rv__n') + B('nzs-sk-rv__mt')) + B('nzs-sk-rv__pr'));
  var AR_P = function(n){ return D('nzs-sk-ar__p', lines(n, 'nzs-sk-ar__l')); };

  var TPL = {
    /* NZS-SKEL-0924: PDP -- breadcrumb band, square gallery + thumb circles, 2-line title, bullet rows, price, swatch tiles. */
    pdp:  D('nzs-sk-pd__crumb', B('nzs-sk-pd__cb')) +
          D('nzs-sk-pd',
            D('nzs-sk-pd__media', B('nzs-sk-pd__gal') + D('nzs-sk-pd__thumbs', fill(4, B('nzs-sk-pd__th')))) +
            D('nzs-sk-pd__info', B('nzs-sk-pd__t') + B('nzs-sk-pd__t nzs-sk-pd__t--2') +
              B('nzs-sk-pd__row') + B('nzs-sk-pd__row nzs-sk-pd__row--2') + B('nzs-sk-pd__row nzs-sk-pd__row--3') +
              B('nzs-sk-pd__price') + B('nzs-sk-pd__ps') + B('nzs-sk-pd__brand') +
              D('nzs-sk-pd__sw', fill(4, B('nzs-sk-pd__tile'))) + B('nzs-sk-pd__atc'))),
    /* NZS-SKEL-0924: collection -- dark hero (crumbs/title/count), subcollection rail, toolbar pills, product cards. */
    coll: D('nzs-sk-ch', D('nzs-sk-ch__in', B('nzs-sk-on-dark nzs-sk-ch__crumb') + B('nzs-sk-on-dark nzs-sk-ch__t') + B('nzs-sk-on-dark nzs-sk-ch__count'))) +
          D('nzs-nav-sk__wrap nzs-sk-sc', B('nzs-sk-sc__h') + D('nzs-sk-subc__bar') +
            D('nzs-sk-sc__nav', B('nzs-sk-sc__arr') + B('nzs-sk-sc__arr')) + D('nzs-sk-sc__row', fill(8, SUBC_TILE))) +
          D('nzs-sk-pw nzs-sk-cm', TOOLBAR + D('nzs-sk-grid nzs-sk-pgrid', fill(8, PRODUCT_CARD))),
    /* NZS-SKEL-0924: policies + plain pages -- narrow left-aligned text column (title, date, paragraphs, subheads). */
    art:  D('nzs-sk-ar', B('nzs-sk-ar__t') + B('nzs-sk-ar__t nzs-sk-ar__t--2') + B('nzs-sk-ar__em') +
            AR_P(5) + B('nzs-sk-ar__h') + AR_P(4) + B('nzs-sk-ar__h') + AR_P(4) + B('nzs-sk-ar__h') + AR_P(4)),
    /* NZS-SKEL-0924: blog article -- crumb band, chip, 2-3 line title, dek, meta, share circles, 16:9 hero, body. */
    post: D('nzs-nav-sk__wrap nzs-sk-po',
            D('nzs-sk-po__crumb', B('nzs-sk-po__cb')) +
            D('nzs-sk-po__head', B('nzs-sk-po__chip') + lines(3, 'nzs-sk-po__t') + lines(4, 'nzs-sk-po__dek') +
              D('nzs-sk-po__meta', B('nzs-sk-po__mi nzs-sk-po__mi--1') + B('nzs-sk-po__mi nzs-sk-po__mi--2') + B('nzs-sk-po__mi nzs-sk-po__mi--3')) +
              D('nzs-sk-po__share', fill(3, B('nzs-sk-po__sb')))) +
            B('nzs-sk-po__hero') + D('nzs-sk-po__body', lines(5, 'nzs-sk-po__l'))),
    /* NZS-SKEL-0924: FAQ -- centred head + search, then topic list (desktop) / chip row (mobile) + accordion rows. */
    help: D('nzs-nav-sk__wrap nzs-sk-hp',
            D('nzs-sk-hp__head', B('nzs-sk-hp__eb') + B('nzs-sk-hp__t') + lines(4, 'nzs-sk-hp__i') + B('nzs-sk-hp__search')) +
            D('nzs-sk-hp__body',
              D('nzs-sk-hp__nav', B('nzs-sk-hp__nl') + lines(8, 'nzs-sk-hp__nk')) +
              D('nzs-sk-hp__main', B('nzs-sk-hp__gt') + fill(6, D('nzs-sk-hp__item', B('nzs-sk-hp__ic') + D('nzs-sk-hp__q', B('nzs-sk-hp__qt') + B('nzs-sk-hp__qt nzs-sk-hp__qt--2'))))))),
    /* NZS-SKEL-0924: cart -- rows follow the header cart count (1-3); see tplFor(). */
    cart: '',
    review: D('nzs-nav-sk__wrap nzs-sk-rv',
            D('nzs-sk-rv__steps', B('nzs-sk-rv__dot') + B('nzs-sk-rv__lab') + B('nzs-sk-rv__dot') + B('nzs-sk-rv__lab nzs-sk-rv__lab--2')) +
            B('nzs-sk-rv__h') + B('nzs-sk-rv__sub') + B('nzs-sk-rv__sub nzs-sk-rv__sub--2') + B('nzs-sk-rv__go') +
            D('nzs-sk-rv__grid', D('nzs-sk-rv__lines', fill(3, RV_LINE)) +
              D('nzs-sk-rv__sum', B('nzs-sk-rv__sh') + lines(3, 'nzs-sk-rv__sl') + B('nzs-sk-rv__tot') + B('nzs-sk-rv__btn')))),
    /* NZS-SKEL-0924: home -- full-bleed photo with copy + 4 buttons (desktop) / photo then copy (mobile), trust strip, category spotlight. */
    home: D('nzs-sk-h2', B('nzs-sk-h2__photo') +
            D('nzs-sk-h2__copy', B('nzs-sk-on-dark nzs-sk-h2__eb') + lines(3, 'nzs-sk-on-dark nzs-sk-h2__t') + lines(3, 'nzs-sk-on-dark nzs-sk-h2__p') +
              D('nzs-sk-h2__btns', lines(4, 'nzs-sk-on-dark nzs-sk-h2__btn')))) +
          D('nzs-sk-h2trust', D('nzs-nav-sk__wrap nzs-sk-h2trust__in', lines(4, 'nzs-sk-on-brand nzs-sk-h2trust__i'))) +
          D('nzs-nav-sk__wrap nzs-sk-h2cat', B('nzs-sk-h2cat__h') +
            D('nzs-sk-h2cat__grid', D('nzs-sk-h2cat__list', fill(6, B('nzs-sk-h2cat__n'))) + B('nzs-sk-h2cat__stage'))),
    /* NZS-SKEL-0924: /pages/compare -- title, lead, category tabs, help line and the empty-state prompt (no grid until a tab is picked). */
    compare: D('nzs-nav-sk__wrap nzs-sk-cp', B('nzs-sk-cp__h') + lines(3, 'nzs-sk-cp__l') +
            D('nzs-sk-cp__tabs', lines(9, 'nzs-sk-cp__tab')) + B('nzs-sk-cp__help') + B('nzs-sk-cp__ph')),
    search: D('nzs-sk-pw nzs-sk-sr', B('nzs-sk-sr__h') +
            D('nzs-sk-sr__field', B('nzs-sk-sr__in') + B('nzs-sk-sr__go')) +
            TOOLBAR + D('nzs-sk-grid nzs-sk-pgrid', fill(8, PRODUCT_CARD))),
    /* NZS-SKEL-0924: themed stack pages (nzs-day-stack) -- centred head, 4 product slots. */
    stack: D('nzs-nav-sk__wrap nzs-sk-ds', D('nzs-sk-ds__head', B('nzs-sk-ds__eb') + lines(2, 'nzs-sk-ds__h') + lines(4, 'nzs-sk-ds__p')) +
            D('nzs-sk-ds__row', fill(4, DS_SLOT))),
    /* NZS-SKEL-0924: /pages/build-your-stack -- dark hero, supply pills, tier cards, first step block. */
    builder: D('nzs-sk-bd', D('nzs-nav-sk__wrap nzs-sk-bd__in', B('nzs-sk-on-dark nzs-sk-bd__eb') + B('nzs-sk-on-dark nzs-sk-bd__t') +
              lines(4, 'nzs-sk-on-dark nzs-sk-bd__sub') + B('nzs-sk-on-dark nzs-sk-bd__lab') +
              D('nzs-sk-bd__opts', B('nzs-sk-bd__opt nzs-sk-bd__opt--on') + B('nzs-sk-on-dark nzs-sk-bd__opt')) +
              lines(2, 'nzs-sk-on-dark nzs-sk-bd__promo') +
              D('nzs-sk-bd__tiers', fill(4, D('nzs-sk-bd__tier', B('nzs-sk-on-dark nzs-sk-bd__tn') + B('nzs-sk-on-dark nzs-sk-bd__tp') + B('nzs-sk-on-dark nzs-sk-bd__tx')))))) +
            D('nzs-nav-sk__wrap nzs-sk-bd__body', D('nzs-sk-bd__blk', B('nzs-sk-bd__num') + D('nzs-sk-bd__bt', B('nzs-sk-bd__bh') + B('nzs-sk-bd__bp')) + B('nzs-sk-bd__pick'))),
    quiz: D('nzs-nav-sk__wrap nzs-sk-qz', D('nzs-sk-qz__head', B('nzs-sk-qz__eb') + lines(2, 'nzs-sk-qz__t') + lines(3, 'nzs-sk-qz__l') + B('nzs-sk-qz__btn') + B('nzs-sk-qz__trust')) +
            B('nzs-sk-qz__h2') + D('nzs-sk-qz__steps', fill(3, D('nzs-sk-qz__step', B('nzs-sk-qz__num') + B('nzs-sk-qz__st') + lines(2, 'nzs-sk-qz__sp')))) +
            B('nzs-sk-qz__h2') + D('nzs-sk-qz__goals', fill(5, D('nzs-sk-qz__goal', B('nzs-sk-qz__gm') + D('nzs-sk-qz__gt', B('nzs-sk-qz__gn') + B('nzs-sk-qz__gs')) + B('nzs-sk-qz__gc'))))),
    /* NZS-SKEL-0924: /collections -- no hero; H1 then square-image tiles with centred 2-line titles. */
    listcoll: D('nzs-sk-pw nzs-sk-lc', B('nzs-sk-lc__h') + D('nzs-sk-grid nzs-sk-lc__grid', fill(10, LIST_TILE))),
    shopidx:  IDX('goal', GOAL_CARD, 8),
    brandidx: IDX('brand', BRAND_CARD, 15),
    catidx:   IDX('cat', CAT_CARD, 6),
    /* NZS-SKEL-0924: blog index -- eyebrow, 2-line title, sub, search pill, featured post, filter chips, 3-up cards. */
    blog: D('nzs-nav-sk__wrap nzs-sk-bl',
            D('nzs-sk-bl__head', B('nzs-sk-bl__eb') + lines(2, 'nzs-sk-bl__t') + lines(2, 'nzs-sk-bl__sub')) +
            B('nzs-sk-bl__search') +
            D('nzs-sk-bl__feat', B('nzs-sk-bl__fm') + D('nzs-sk-bl__fb', lines(2, 'nzs-sk-bl__ft') + lines(3, 'nzs-sk-bl__fx') + B('nzs-sk-bl__fd') + B('nzs-sk-bl__fr'))) +
            D('nzs-sk-bl__chips', lines(8, 'nzs-sk-bl__chip')) +
            D('nzs-sk-grid nzs-sk-bl__grid', fill(6, BLOG_CARD))),
    bar:  ''                                            // unmatched: top progress bar only
  };
  /* NZS-SKEL-0924: the cart wireframe draws as many line rows as the header cart count shows (clamped 1-3). */
  function cartTpl(){
    var n = 0;
    try { [].forEach.call(document.querySelectorAll('.cartdot'), function(d){ n = Math.max(n, parseInt(d.textContent, 10) || 0); }); } catch (_){}
    n = Math.min(3, Math.max(1, n));
    return D('nzs-sk-pw nzs-sk-ct', D('nzs-sk-ct__top', B('nzs-sk-ct__h') + B('nzs-sk-ct__cont')) +
      D('nzs-sk-ct__layout',
        D('nzs-sk-ct__items', D('nzs-sk-ct__rew', B('nzs-sk-ct__msg') + B('nzs-sk-ct__fill')) + fill(n, CART_ROW) +
          D('nzs-sk-ct__est', B('nzs-sk-ct__et') + D('nzs-sk-ct__ef', lines(3, 'nzs-sk-ct__ei')))) +
        D('nzs-sk-ct__sum', B('nzs-sk-ct__st') + B('nzs-sk-ct__nl') + B('nzs-sk-ct__note') + lines(3, 'nzs-sk-ct__sl') + B('nzs-sk-ct__btn'))));
  }
  function tplFor(k){ return k === 'cart' ? cartTpl() : (TPL[k] || ''); }

  (function assertTemplates(){
    function safeMap(map, label){
      if (!map || typeof map !== 'object') {
        if (window.console && console.error) console.error('[nzs-skeleton] invalid ' + label + '; using bar fallback');
        return {};
      }
      for (var key in map) {
        if (HAS.call(map, key) && !HAS.call(TPL, map[key])) {
          if (window.console && console.error) console.error('[nzs-skeleton] missing TPL for ' + label + ' kind "' + map[key] + '"; using bar fallback');
          map[key] = 'bar';
        }
      }
      return map;
    }
    PAGE_KIND = safeMap(PAGE_KIND, 'PAGE_KIND');
    SUFFIX_KIND = safeMap(SUFFIX_KIND, 'SUFFIX_KIND');
  })();

  function routeRoot(){
    var root = '/';
    try {
      root = window.Shopify && Shopify.routes && typeof Shopify.routes.root === 'string' ? Shopify.routes.root : '/';
      root = new URL(root || '/', location.origin).pathname;
    } catch (_){ root = '/'; }
    if (root.charAt(0) !== '/') root = '/' + root;
    return root.replace(/\/+$/, '') || '/';
  }

  function normalise(pathname){
    var p = typeof pathname === 'string' && pathname ? pathname : '/';
    try { p = new URL(p, location.href).pathname; } catch (_){}
    if (p.charAt(0) !== '/') p = '/' + p;
    p = p.replace(/\/+$/, '') || '/';
    var root = routeRoot();                            // root is trailing-slash-normalised before comparison
    if (root !== '/' && (p === root || p.indexOf(root + '/') === 0)) p = p.slice(root.length) || '/';
    return p.replace(/\/+$/, '') || '/';              // stripping the locale root can produce an empty string
  }

  function healedKind(path){
    var suffix = null, healed;
    try { suffix = sessionStorage.getItem(SELF_KEY + path); } catch (_){}
    if (suffix === null) return null;
    healed = HAS.call(SUFFIX_KIND, suffix) ? SUFFIX_KIND[suffix] : 'bar';
    return HAS.call(TPL, healed) ? healed : 'bar';
  }

  function rememberCurrentSuffix(){
    var main = document.getElementById('MainContent');
    if (!main) return;
    var marker = 'theme-template-suffix-', classes = String(main.className || '').split(/\s+/), suffix = null;
    for (var i = 0; i < classes.length; i++) {
      if (classes[i].indexOf(marker) === 0) { suffix = classes[i].slice(marker.length); break; }
    }
    if (suffix === null) return;
    try { sessionStorage.setItem(SELF_KEY + normalise(location.pathname), suffix); } catch (_){}
  }

  function kind(pathname){
    var p = normalise(pathname), m, mapped, healed;
    if (/^\/$/.test(p))                                      return 'home';
    if (/^\/products\/[^/]+$/.test(p))                       return 'pdp';
    if (/^\/collections\/[^/]+\/products\/[^/]+$/.test(p))   return 'pdp';
    if (/^\/collections$/.test(p))                           return 'listcoll';
    if (/^\/collections\/[^/]+$/.test(p))                    return 'coll';
    if (/^\/search$/.test(p))                                return 'search';
    m = p.match(/^\/pages\/([^/]+)$/);
    if (m) {
      mapped = PAGE_KIND && typeof PAGE_KIND === 'object' ? PAGE_KIND[m[1]] : null;
      if (typeof mapped === 'string' && HAS.call(TPL, mapped)) return mapped;
      healed = healedKind(p);
      return healed || 'bar';
    }
    if (/^\/blogs\/[^/]+\/tagged\/[^/]+$/.test(p))           return 'blog';
    if (/^\/blogs\/[^/]+$/.test(p))                          return 'blog';
    if (/^\/blogs\/[^/]+\/[^/]+$/.test(p))                   return 'post';   /* NZS-SKEL-0924: article wireframe */
    if (/^\/policies\/[^/]+$/.test(p))                       return 'art';
    if (/^\/cart$/.test(p))                                  return 'cart';
    if (/^\/account(?:\/|$)/.test(p))                         return 'bar';    /* NZS-SKEL-0924: /account redirects to shopify.com customer accounts; no theme page to mirror */
    return 'bar';
  }

  function destination(u){
    if (normalise(u.pathname) === normalise(location.pathname)) return 'bar';
    return kind(u.pathname);
  }

  function darkNow(){
    if (document.documentElement && document.documentElement.classList.contains('dark')) return true;
    try { return String(localStorage.eurus_theme) === '1'; } catch (_){ return false; }
  }

  /* NZS-SPD-0927-SM-INERT (owner-approved 28 Sep, deferred page-lock): the support check, the focus capture and the
     opaque-wireframe decision stay in show(); the inert write itself (a whole-document style invalidation, 110-460 ms on a
     4x phone) is applyInert(), run from show() in a task after the skeleton's first frame. The overlay already covers the
     page below the header meanwhile. hide() drops a write that has not landed (inertGen). */
  var inertGen = 0;
  function prepareInert(k){
    if (k === 'bar') return k;
    var main = document.querySelector('.main-container');
    if (!main || !('inert' in main)) return 'bar';
    inertRoot = main;
    inertSet = false;
    focusEl = main.contains(document.activeElement) ? document.activeElement : null;
    return k;
  }
  function applyInert(gen){
    var main = inertRoot;
    if (gen !== inertGen || !main || !el) return;
    inertSet = !main.inert;
    if (inertSet) main.inert = true;
  }

  function show(k){
    if (el) return;                                     // never stack overlays
    /* NZS-SK-CLOSESURF-0821 (Blake): dismiss any open header overlay (search, mega, mobile nav)
       the instant a navigation commits, BEFORE the wireframe paints — so clicking a product/
       collection out of the search panel no longer skeleton-loads with the search still covering
       the page. Uses each surface's own closer (state stays consistent); '' matches no key, so
       every registered surface closes. No-op when nothing is open. */
    /* NZS-SKCLOSE-0903 (Blake): html.nzs-sk-on kills transitions (nzs-base.css) so those closes
       are instant - no drawer/pane sliding away while the next page loads. hide() removes it. */
    /* NZS-SPD-0927-SM-N2: the header height is read FIRST, before any document-wide write, so the style+layout flush it
       needs covers only the header (it used to run again after nzs-sk-on + inert had invalidated the whole document).
       Same value: .nzs-sk-hdr kills transitions inside the header only, exactly as html.nzs-sk-on * does a line later (a
       compact/expand height transition in flight resolves to its end value either way), and nothing the next lines do
       can move the header box (position:fixed; the mega drawer and the search bar are absolute, the mobile nav and the
       drawers are separate fixed layers; html{scrollbar-gutter:stable} holds the width when a scroll lock releases). */
    var _hdr = document.querySelector('.site-header');
    if (_hdr) _hdr.classList.add('nzs-sk-hdr');
    var _hdrH = _hdr ? Math.round(_hdr.getBoundingClientRect().height) : 0;
    document.documentElement.classList.add('nzs-sk-on');
    /* NZS-SPD-0927-SM-N1: close every surface WITHOUT restoring focus (the page is leaving; a restore forced a second
       whole-document recalc in menu flows). */
    try { if (window.__nzsCloseAllExcept) window.__nzsCloseAllExcept('', { restoreFocus: false }); } catch (_){}
    k = prepareInert(k);                               // unsupported inert must use the non-opaque bar
    el = document.createElement('div');
    el.className = 'nzs-nav-sk nzs-nav-sk--' + k + (darkNow() && k !== 'bar' ? ' nzs-nav-sk--dark' : '');
    el.setAttribute('aria-hidden', 'true');
    /* NZS-SK-BELOW-HEADER (Blake 2026-07-31): --nzs-sk-top was a hardcoded 88px, but the
       header is a fixed 110px (105px mid-breakpoint) since it stopped shrinking on scroll,
       so the overlay began inside the header and clipped its lower edge. Measure the real
       thing instead of trusting a constant — this then tracks any future header change and
       every breakpoint for free. The inline value rides along in the sessionStorage
       outerHTML used for the warm handoff, which is correct: the next document's header is
       the same height. */
    if (_hdrH > 0) el.style.setProperty('--nzs-sk-top', _hdrH + 'px');   /* NZS-SPD-0927-SM-N2: measured at the top of show() */
    el.innerHTML = tplFor(k); /* NZS-SKBAR-0903: no progress bar. NZS-SKEL-0924: cart rows follow the cart count */
    document.body.appendChild(el);
    if (statusTick){ clearTimeout(statusTick); statusTick = null; }
    statusTick = setTimeout(function(){
      statusTick = null;
      if (statusEl) statusEl.textContent = 'Loading page';
    }, 0);

    try {
      if (k === 'bar') { sessionStorage.removeItem('nzsSkNav'); sessionStorage.removeItem('nzsSkNavAt'); }
      else { sessionStorage.setItem('nzsSkNavAt', String(Date.now())); sessionStorage.setItem('nzsSkNav', el.outerHTML); }
    } catch (_){}
    /* NZS-SPD-0927-SM-INERT: the page inert lands in a task after the skeleton's first frame. The shimmer runs from that
       first frame (nzs-base.css SM-SHIM, a composited transform), so it keeps moving through the recalc. */
    var _gen = ++inertGen;
    requestAnimationFrame(function(){ setTimeout(function(){ applyInert(_gen); }, 0); });
    safety = setTimeout(hide, SAFETY);                  // retain id so every terminal path can clear it
  }

  function hide(){
    inertGen++;   /* NZS-SPD-0927-SM-INERT: drop an inert write that has not landed */
    document.documentElement.classList.remove('nzs-sk-on');
    var _hdrOn = document.querySelector('.site-header.nzs-sk-hdr'); if (_hdrOn) _hdrOn.classList.remove('nzs-sk-hdr');   /* NZS-SPD-0927-SM-N2 */
    try { sessionStorage.removeItem('nzsSkNav'); sessionStorage.removeItem('nzsSkNavAt'); } catch (_){}
    if (safety){ clearTimeout(safety); safety = null; }
    if (statusTick){ clearTimeout(statusTick); statusTick = null; }
    if (el && el.parentNode) el.parentNode.removeChild(el);
    if (statusEl) statusEl.textContent = '';
    el = null;
    if (inertRoot && inertSet) inertRoot.inert = false;
    var restore = focusEl;
    inertRoot = null;
    inertSet = false;
    focusEl = null;
    if (restore && restore.isConnected !== false && typeof restore.focus === 'function') {
      try { restore.focus({ preventScroll: true }); } catch (_) { try { restore.focus(); } catch (__) {} }
    }
    if (t){ clearTimeout(t); t = null; }
  }

  statusEl = document.createElement('span');            // persistent body sibling: the overlay is aria-hidden
  statusEl.className = 'nzs-nav-sk__status';
  statusEl.setAttribute('role', 'status');
  statusEl.setAttribute('aria-live', 'polite');
  statusEl.setAttribute('aria-atomic', 'true');
  document.body.appendChild(statusEl);
  rememberCurrentSuffix();

  /* NZS-OFFERS-0820 r3: programmatic navigation with the skeleton — the cart drawer's
     Recently-Viewed pane closes the drawer first, then calls this to show the wireframe and go. */
  window.__nzsNavSkTo = function(href){
    var u; try { u = new URL(href, location.href); } catch (_) { location.assign(href); return; }
    try { show(destination(u)); } catch (_) {}
    location.assign(u.href);
  };
  document.addEventListener('click', function(e){
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a');
    if (!a) return;
    if (a.target && a.target !== '_self') return;       // opens new tab/frame
    if (a.hasAttribute('download') || a.hasAttribute('data-no-skeleton')) return;
    if (a.closest('[data-no-skeleton]')) return;
    var href = a.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#' || /^(mailto:|tel:|sms:|javascript:)/i.test(href)) return;
    var u; try { u = new URL(a.href, location.href); } catch (_){ return; }
    if (u.origin !== location.origin) return;                                   // cross-origin
    if (u.pathname === location.pathname && u.search === location.search) return; // same page / hash jump
    if (/\/checkout(\/|$)/.test(u.pathname)) return;                            // checkout only (account shows the skeleton)
    var dest = destination(u);
    // Fire after a short delay so fast loads never flash; at fire-time re-check defaultPrevented so
    // client-intercepted links (filters, swatches, quick-view, cart toggle — all call preventDefault
    // in the bubble phase, after this capture handler) never leave a stuck overlay.
    if (t){ clearTimeout(t); t = null; }
    t = setTimeout(function(){ t = null; if (!e.defaultPrevented) show(dest); }, DELAY);
  }, true);

  window.addEventListener('pageshow', function(ev){ if (ev.persisted) hide(); }); // bfcache Back
  window.addEventListener('popstate', hide);
})();
